<template>
  <img
    @click="$emit('click')"
    :style="`display: block; object-fit: contain; height: ${computedSize}px; width: ${computedSize}px;`"
    :src="url"
  />
</template>

<script>
const sizes = {
  small: 24,
  medium: 36,
  large: 60,
  xlarge: 90,
};

export default {
  name: 'icon',

  props: {
    // Good to type it explicitly so IDE can give us hints
    // this.icons will return one of the following key names which
    // has the value "true"
    addcolleague: Boolean,
    clock: Boolean,
    energy: Boolean,
    idea: Boolean,
    logout: Boolean,
    notification: Boolean,
    globe: Boolean,
    settings: Boolean,
    trash: Boolean,
    download: Boolean,
    cancel: Boolean,
    cross: Boolean,
    favourite: Boolean,
    sadsmilesvg: Boolean,
    location: Boolean,
    megaphone: Boolean,
    rocket: Boolean,
    stats: Boolean,
    tick: Boolean,
    blueTick: Boolean,
    blueBlueTick: Boolean,
    thumbsup: Boolean,
    signal: Boolean,
    star: Boolean,
    plus: Boolean,
    whiteCancel: Boolean,
    whiteTrash: Boolean,
    addColleagueNew: Boolean,
    addPhoto: Boolean,
    agreement: Boolean,
    at: Boolean,
    barcode: Boolean,
    beacons: Boolean,
    buy: Boolean,
    campaign: Boolean,
    coupon: Boolean,
    datetime: Boolean,
    delete: Boolean,
    deleteSure: Boolean,
    doneRedeem: Boolean,
    information: Boolean,
    inviteAuth: Boolean,
    launch: Boolean,
    login: Boolean,
    register: Boolean,
    notificationNew: Boolean,
    partnership: Boolean,
    qrCode: Boolean,
    resetPass: Boolean,
    signup: Boolean,
    statsAgenda: Boolean,
    statsAllCoupons: Boolean,
    statsCoupon: Boolean,
    support: Boolean,
    hihelloLogo: Boolean,
    pencil: Boolean,
    sliders: Boolean,
    calculator: Boolean,

    small: Boolean,
    medium: Boolean,
    large: Boolean,
    xlarge: Boolean,

    iconName: String,
    rotate: { type: Number },
    size: { type: Number, default: 24 },
    pxResolutionPerSize: { type: Number, default: 1.4 },
    fileType: { type: String, default: 'svg' },
  },

  computed: {
    computedSize() {
      if (this.small) {
        return sizes.small;
      }

      if (this.medium) {
        return sizes.medium;
      }

      if (this.large) {
        return sizes.large;
      }

      if (this.xlarge) {
        return sizes.xlarge;
      }

      return this.size;
    },

    icon() {
      // Get which key is true from props, filtering for not-icon names like 'size'
      const icon = (Object.entries(this.$props)
        .filter(v => ![
          'small',
          'medium',
          'large',
          'xlarge',
          'iconName',
          'rotate',
          'size',
          'pxResolutionPerSize',
          'fileType',
        ].includes(v[0]))
        .find(v => v[1]) || [])[0] || this.iconName;

      if (!icon) {
        throw Error('No icon or iconName was supplied to <icon/>');
      }

      return icon;
    },

    rotateManipulation() {
      if (!this.rotate) { return ''; }
      return `a_${this.rotate}/`;
    },

    url() {
      const folder = 'icons/';
      const manipulations = this.rotateManipulation;
      return `${this.$CONSTANTS.cloudinary.url}${manipulations}${folder}${this.icon}.${this.fileType}`;
    },
  },
};
</script>
